/**
 * Chat export artefacts use `/chat/exports/download` on the ml-scribe API.
 * That endpoint 302-redirects to a presigned S3 URL. Loading the PDF with
 * `fetch` / pdf.js follows the redirect and hits S3 without CORS headers for
 * the app origin, so inline preview must use navigational loading (iframe)
 * instead.
 */

const CHAT_EXPORT_DOWNLOAD_PATH_SUFFIX = '/chat/exports/download';

function isTrustedExportDownloadHostname(hostname: string): boolean {
  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]') {
    return true;
  }
  if (hostname === 'heidihealth.com' || hostname.endsWith('.heidihealth.com')) {
    return true;
  }
  if (typeof window !== 'undefined' && hostname === window.location.hostname) {
    return true;
  }
  return false;
}

export function isChatExportDownloadUrl(url: string): boolean {
  try {
    const parsed = new URL(
      url,
      typeof window !== 'undefined' ? window.location.origin : 'https://localhost'
    );
    if (!isTrustedExportDownloadHostname(parsed.hostname)) {
      return false;
    }
    return parsed.pathname.endsWith(CHAT_EXPORT_DOWNLOAD_PATH_SUFFIX);
  } catch {
    return false;
  }
}
